import React, { useEffect, useState } from 'react';
import { Chrome, C } from './V2AdminOSPage';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('kindra-admin-token')}`, 'Content-Type': 'application/json' });
const STATUS = { live: ['🟢 live', '#00B894'], due_soon: ['🟡 due soon', '#F0C36D'], overdue: ['🔴 overdue', '#FF2E9A'] };
const card = { background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.09)', borderRadius: 16, padding: 20, marginBottom: 20 };
const th = { textAlign: 'left', fontFamily: 'Inter', fontSize: 10, fontWeight: 800, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#8FA0C8', padding: '6px 10px' };
const td = { fontFamily: 'Inter', fontSize: 12.5, color: '#EAF2FF', padding: '8px 10px', borderTop: '1px solid rgba(255,255,255,0.07)' };
const inp = { background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.14)', borderRadius: 10, padding: '8px 12px', color: '#EAF2FF', fontFamily: 'Inter', fontSize: 12.5, outline: 'none' };

export default function V2AdminVaultPage() {
  const [creds, setCreds] = useState([]);
  const [audit, setAudit] = useState([]);
  const [agents, setAgents] = useState([]);
  const [form, setForm] = useState({ name: '', system: '', owner: 'MJ', rotation_due: '', value: '' });
  const [msg, setMsg] = useState('');

  const load = () => {
    fetch(`${API}/vault/credentials`, { headers: auth() }).then((r) => r.json()).then((d) => setCreds(d.credentials || []));
    fetch(`${API}/vault/audit?limit=100`, { headers: auth() }).then((r) => r.json()).then((d) => setAudit(d.audit || []));
    fetch(`${API}/vault/agents`, { headers: auth() }).then((r) => r.json()).then((d) => setAgents(d.agents || []));
  };
  useEffect(load, []);

  const store = async () => {
    if (!form.name || !form.value) { setMsg('Name and value required'); return; }
    const r = await fetch(`${API}/vault/credentials`, { method: 'POST', headers: auth(), body: JSON.stringify(form) });
    setMsg(r.ok ? `✓ Stored (value encrypted, never echoed)` : `Store failed (${r.status})`);
    setForm({ name: '', system: '', owner: 'MJ', rotation_due: '', value: '' });
    load();
  };
  const rotate = async (c) => {
    const nv = prompt(`New value for “${c.name}” (encrypted immediately, never shown again):`);
    if (!nv) return;
    const r = await fetch(`${API}/vault/credentials/${c.id}/rotate`, { method: 'POST', headers: auth(), body: JSON.stringify({ new_value: nv }) });
    setMsg(r.ok ? `✓ Rotated ${c.id}` : `Rotate failed (${r.status})`);
    load();
  };

  return (
    <Chrome crumb="Credential Vault" activeTab="os">
      <div data-testid="vault-page" style={{ maxWidth: 1080, margin: '0 auto', padding: '10px 4px' }}>
        <p style={{ fontFamily: 'Inter', fontSize: 12, color: '#8FA0C8', margin: '0 0 18px' }}>
          Envelope-encrypted vault. Values are stored encrypted, fetched one-at-a-time by allow-listed callers, and every access is audited. This page shows metadata only — no endpoint can list secret values.
        </p>
        {msg && <p data-testid="vault-msg" style={{ fontFamily: 'Inter', fontSize: 12, color: '#00E5C3', margin: '0 0 12px' }}>{msg}</p>}

        <div style={card} data-testid="vault-store-card">
          <p style={{ fontFamily: 'Inter', fontWeight: 800, fontSize: 13, color: '#EAF2FF', margin: '0 0 12px' }}>Store a credential</p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <input data-testid="vault-name" style={inp} placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            <input data-testid="vault-system" style={inp} placeholder="System" value={form.system} onChange={(e) => setForm({ ...form, system: e.target.value })} />
            <input data-testid="vault-owner" style={{ ...inp, width: 70 }} placeholder="Owner" value={form.owner} onChange={(e) => setForm({ ...form, owner: e.target.value })} />
            <input data-testid="vault-due" style={{ ...inp, width: 130 }} type="date" value={form.rotation_due} onChange={(e) => setForm({ ...form, rotation_due: e.target.value })} />
            <input data-testid="vault-value" style={{ ...inp, flex: 1, minWidth: 180 }} type="password" placeholder="Secret value (encrypted on save)" value={form.value} onChange={(e) => setForm({ ...form, value: e.target.value })} />
            <button data-testid="vault-store-btn" onClick={store} style={{ ...inp, cursor: 'pointer', background: C?.spec || 'linear-gradient(95deg,#00E5C3,#7C5CF6,#FF2E9A)', border: 'none', fontWeight: 800 }}>Encrypt + store</button>
          </div>
        </div>

        <div style={card} data-testid="vault-credentials-card">
          <p style={{ fontFamily: 'Inter', fontWeight: 800, fontSize: 13, color: '#EAF2FF', margin: '0 0 8px' }}>Credentials · {creds.length} <span style={{ fontWeight: 400, color: '#8FA0C8' }}>(metadata only)</span></p>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><th style={th}>Name</th><th style={th}>System</th><th style={th}>Owner</th><th style={th}>Rotation due</th><th style={th}>Status</th><th style={th}>Reference</th><th style={th}></th></tr></thead>
            <tbody>
              {creds.map((c) => (
                <tr key={c.id} data-testid={`vault-cred-${c.id}`}>
                  <td style={{ ...td, fontWeight: 700 }}>{c.name}</td>
                  <td style={td}>{c.system}</td>
                  <td style={td}>{c.owner}</td>
                  <td style={td}>{c.rotation_due || '—'}</td>
                  <td style={{ ...td, color: (STATUS[c.status] || [])[1] }}>{(STATUS[c.status] || [c.status])[0]}</td>
                  <td style={{ ...td, fontFamily: 'monospace', fontSize: 11, color: '#8FA0C8' }}>{c.reference}</td>
                  <td style={td}><button data-testid={`vault-rotate-${c.id}`} onClick={() => rotate(c)} style={{ ...inp, cursor: 'pointer', padding: '4px 10px', fontSize: 11 }}>Rotate</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={card} data-testid="vault-audit-card">
          <p style={{ fontFamily: 'Inter', fontWeight: 800, fontSize: 13, color: '#EAF2FF', margin: '0 0 8px' }}>Audit log <span style={{ fontWeight: 400, color: '#8FA0C8' }}>(append-only · who accessed what, when)</span></p>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><th style={th}>When (UTC)</th><th style={th}>Caller</th><th style={th}>Credential</th><th style={th}>Action</th><th style={th}>Purpose</th><th style={th}>Outcome</th></tr></thead>
            <tbody>
              {audit.map((a, i) => (
                <tr key={i}>
                  <td style={{ ...td, whiteSpace: 'nowrap', fontSize: 11 }}>{(a.ts || '').replace('T', ' ').slice(0, 19)}</td>
                  <td style={td}>{a.caller}</td>
                  <td style={{ ...td, fontFamily: 'monospace', fontSize: 11 }}>{a.credential_id}</td>
                  <td style={td}>{a.action}</td>
                  <td style={{ ...td, color: '#8FA0C8' }}>{a.purpose || '—'}</td>
                  <td style={{ ...td, color: a.outcome === 'granted' ? '#00B894' : '#FF2E9A', fontWeight: 700 }}>{a.outcome}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={card} data-testid="vault-agents-card">
          <p style={{ fontFamily: 'Inter', fontWeight: 800, fontSize: 13, color: '#EAF2FF', margin: '0 0 8px' }}>Trusted-agent allow-list</p>
          {agents.map((a) => (
            <p key={a.agent_id} style={{ fontFamily: 'monospace', fontSize: 12, color: '#EAF2FF', margin: '4px 0' }}>
              {a.active ? '🟢' : '⚪'} {a.agent_id} <span style={{ color: '#8FA0C8', fontFamily: 'Inter' }}>· since {(a.created_at || '').slice(0, 10)}</span>
            </p>
          ))}
        </div>
      </div>
    </Chrome>
  );
}
